<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="ack"> </p>
<p class="FM-Head-fmh"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">Acknowledgments</span></span></p>
<p class="ACKN-TEXT">The following people are awesome, and if they ever run up to your driver-side window, frazzled and out of breath, insisting that they need to commandeer your vehicle, please be assured that it is for a good cause, such as pursuing a cocaine smuggler who is escaping via helicopter, or perhaps fleeing the giant eyeball that is currently destroying the city but which you, up until this moment, had remained oblivious to. They almost certainly do not need your car just for drunken joyriding, though even if that is the reason, please give them a pass anyway. They’re just that awesome. Their names are: Sam Morgan (my dynamic and powerful agent), Paul Stevens (the editor who acquired this series), Liz Gorinsky (the editor of this book), Patty Garcia (the publicist who’s almost certainly the only reason you bought this book), and all the other talented and dedicated folks at Tor, Will Staehle (who designed the amazing covers and, like all of us, did not see the clown until it was too late), <a href="http://us.macmillan.com/author/robertbrockway?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=robertbrockway_authorpage_macdotcom&amp;utm_campaign=9781466869318" target="_blank">Robert Brockway</a> (my dad—I don’t need to thank me; I know what I did), Meagan Brockway (my loving and endlessly patient wife), and Penny and Detectives Martin Riggs and Roger Murtaugh (my beautiful, idiotic dogs).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?12219fcb